import { z } from 'zod';
import { PERSON_NAME_MAX_LENGTH, PERSON_NAME_REGEX, personNameRegexMessage, safeTextSchema } from '@petseo/shared';

export const EMPLOYEE_POSITION_MAX_LENGTH = 60;

export const employeeSchema = z.object({
  firstName: z
    .string()
    .min(1, 'Imię jest wymagane')
    .max(PERSON_NAME_MAX_LENGTH, `Imię może mieć maksymalnie ${PERSON_NAME_MAX_LENGTH} znaków`)
    .regex(PERSON_NAME_REGEX, personNameRegexMessage('Imię')),
  lastName: z
    .string()
    .min(1, 'Nazwisko jest wymagane')
    .max(PERSON_NAME_MAX_LENGTH, `Nazwisko może mieć maksymalnie ${PERSON_NAME_MAX_LENGTH} znaków`)
    .regex(PERSON_NAME_REGEX, personNameRegexMessage('Nazwisko')),
  position: safeTextSchema('Stanowisko', { max: EMPLOYEE_POSITION_MAX_LENGTH, required: false }).optional().or(z.literal('')),
});

export type EmployeeFormData = z.infer<typeof employeeSchema>;
